import * as React from "react";

const MobileBg = ({
  color1 = "#1D1D1D",
  color2 = "#61FF00",
  color3 = "#AE0000",
}) => (
  <svg width={375} height={1080} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m-36.705 967.321 17.79-17.789V831.511l23.718-23.719M339.356 933.464h51.455L413 911.276"
      stroke={color1}
      strokeWidth={0.383}
    />
    <path
      d="M339.548 1041.73v-28.69l10.711-16.644v-49.159l-10.711-13.773"
      stroke={color1}
      strokeWidth={0.383}
    />
    <path
      d="M279.867 905.813h37.109l33.283 41.424v11.477"
      stroke="#F2F2F2"
      strokeOpacity={0.38}
      strokeWidth={0.383}
    />
    <path
      d="m65.057 797.08-9.758 9.947H5.759l-6.12 6.121"
      stroke={color2}
      strokeWidth={0.383}
    />
    <path
      d="M337.061 627.987v60.445l28.31 28.31"
      stroke={color1}
      strokeWidth={0.383}
    />
    <path
      d="M97.958 1066.41H37.513l-28.31-28.31"
      stroke={color3}
      strokeWidth={0.383}
    />
    <path
      d="m42.104 615.362 32.51-27.545h42.09M327.879 1071.38h-26.312l-7.353 7.65M42.104 671.408v27.162l22.954 22.954V796.889"
      stroke={color1}
      strokeWidth={0.383}
    />
    <path
      d="M65.058 762.075v-40.551L42.104 698.57v-27.162"
      stroke="#F2F2F2"
      strokeOpacity={0.55}
      strokeWidth={0.383}
    />
    <path
      d="M296.127 608.476h21.779l19.155 19.511v12.05"
      stroke={color2}
      strokeWidth={0.383}
    />
    <path
      d="M362.034 787.675h-18.541l-5.112-5.134h-10.912m0 0-6.104 6.131-7.935 7.969m14.039-14.1H313.43l-23.425-23.677v-12.951"
      stroke={color3}
      strokeWidth={0.383}
    />
    <circle
      r={0.659}
      transform="matrix(1 0 0 -1 362.034 787.857)"
      fill={color3}
    />
    <circle
      r={0.439}
      transform="matrix(1 0 0 -1 313.503 796.641)"
      fill={color3}
    />
    <circle
      r={1.148}
      transform="matrix(1 0 0 -1 42.104 615.362)"
      fill={color1}
    />
    <circle r={1.148} transform="matrix(1 0 0 -1 9.203 1038.1)" fill={color3} />
    <path
      d="m-3.879 104.246 16.442 16.442v109.08l21.922 21.922M343.693 135.538h47.557l20.508 20.508M343.87 35.474v26.519l9.9 15.38v45.436l-9.9 12.729"
      stroke={color1}
      strokeWidth={0.354}
    />
    <path
      d="m242.568 38.225 12.97-12.828h78.571l9.938 9.937"
      stroke="#80FF00"
      strokeWidth={0.354}
    />
    <path
      d="M288.711 161.095h34.297l30.762-38.286v-10.607"
      stroke="#F2F2F2"
      strokeOpacity={0.38}
      strokeWidth={0.354}
    />
    <path
      d="m90.174 261.59-9.019-9.193H35.37l-5.657-5.657"
      stroke={color2}
      strokeWidth={0.354}
    />
    <path
      d="M341.572 417.874v-55.866l26.165-26.165"
      stroke={color1}
      strokeWidth={0.354}
    />
    <path
      d="M120.583 12.668H64.716L38.551 38.833"
      stroke={color3}
      strokeWidth={0.354}
    />
    <path
      d="M68.96 429.542 99.007 455h38.901M333.086 8.072h-24.319L301.97 1M68.96 377.742v-25.104l21.214-21.215v-69.656"
      stroke={color1}
      strokeWidth={0.354}
    />
    <path
      d="M90.175 293.943v37.48L68.96 352.638v25.104"
      stroke="#F2F2F2"
      strokeOpacity={0.55}
      strokeWidth={0.354}
    />
    <path
      d="M303.738 435.907h20.13l17.704-18.033v-11.138"
      stroke={color2}
      strokeWidth={0.354}
    />
    <circle cx={38.551} cy={38.833} r={1.061} fill={color3} />
    <circle cx={68.96} cy={429.542} r={1.061} fill={color1} />
    <path
      d="M364.653 270.282h-17.137l-4.725 4.746h-10.084m0 0-5.642-5.666-7.334-7.366m12.976 13.032h-12.976l-21.65 21.884v11.969"
      stroke={color3}
      strokeWidth={0.354}
    />
    <circle cx={364.653} cy={270.115} r={0.609} fill={color3} />
    <circle cx={319.798} cy={261.996} r={0.406} fill={color3} />
  </svg>
);

export default MobileBg;
